import { Fragment, useState } from "react";
import "./App.css";
import Navbar from "./components/navbar";
import Landing from "./sections/landing";
import Footer from "./components/footer";
import Skills from "./sections/skills";
import Projects from "./sections/projects";
import background from "./assets/background-web.png";

const styles = {
  container:{
    backgroundImage: `url("${background}")`,
    backgroundAttachment: "fixed"
  }
}

function App() {
  const [footer, setFooter] = useState(false);
  const openFooter = () => {
    setFooter(!footer)
  }
  return (
    <Fragment>
      <Navbar toggle={openFooter} />
      <div style={styles.container}>
        <Landing />
        <Skills />
        <Projects />
      </div>
      {footer && <Footer toggle={setFooter} />}
    </Fragment>
  );
}

export default App;
